import React from 'react';
import { Link } from 'react-router-dom';

import NavigationSidebar, {
  Section,
  SidebarLink
} from 'buyside/components/presentation/NavigationSidebar/NavigationSidebar';
import { RankingIndexJoyrideTarget } from 'buyside/components/presentation/Joyride/RankingIndexJoyride/rankingIndexJoyrideHelper';

const { rankingCategories } = require('buyside/util/constantsFromRails.json');
import { range } from 'buyside/util/lodashAlt';
import { formatCategory } from 'buyside/util/rankCategoryHelper';

const SECTIONS = Object.freeze([
  {
    title: 'Overall',
    categories: range([0, 2]).map(idx => rankingCategories[idx])
  },
  {
    title: 'Market Cap',
    categories: range([2, 6]).map(idx => rankingCategories[idx])
  },
  {
    title: 'Sector',
    categories: range([6, 14]).map(idx => rankingCategories[idx])
  },
  {
    title: 'Direction',
    categories: range([14, 16]).map(idx => rankingCategories[idx])
  },
  {
    title: 'Investment Situation',
    categories: range([16, 20]).map(idx => rankingCategories[idx])
  },
  {
    title: 'Region',
    categories: range([20, 23]).map(idx => rankingCategories[idx])
  }
]);

const CategoryLink = ({ currentCategory, activeCategory }) => {
  const isActive = activeCategory === currentCategory;
  let displayName = formatCategory(currentCategory.replace('_cap', ''));
  if (currentCategory === 'last_twelve_months') {
    displayName = 'Last Twelve Months (LTM)';
  } else if (currentCategory === 'growth_at_reasonable_price') {
    displayName = 'Growth At Reasonable Price';
  }
  return (
    <SidebarLink displayName={displayName} active={isActive}>
      {({ linkStyle, linkContent }) => (
        <Link className={linkStyle} to={'/' + currentCategory}>
          {linkContent}
        </Link>
      )}
    </SidebarLink>
  );
};

const RankingsSidebar = ({ category: activeCategory }) => {
  return (
    <NavigationSidebar joyrideTarget={RankingIndexJoyrideTarget.RANKINGS_BY_CATEGORY}>
      {SECTIONS.map((section, idx) => {
        return (
          <Section title={section.title} key={idx}>
            {section.categories.map((currentCategory, idx) => (
              <CategoryLink
                currentCategory={currentCategory}
                activeCategory={activeCategory}
                key={idx}
              />
            ))}
          </Section>
        );
      })}
    </NavigationSidebar>
  );
};

export default RankingsSidebar;
